/** When your routing table is too long, you can split it into small modules */
import Login from '@/pages/Login/Login.vue';
import FourZeroOne from '@/pages/FourZeroOne/FourZeroOne.vue';
import NotificationTaskAction from '@/pages/NotificationTaskAction/NotificationTaskAction.vue';
import getAuthenticatedUser from '@/api/AuthenticatedUser';

const authRouter = [
  {
    path: '/login/:ssoProvider?',
    name: 'login',
    component: Login,
    hidden: true,
    beforeEnter: async (to, from, next) => {
      try {
        const currentUser = await getAuthenticatedUser();
        if (currentUser) {
          next({ path: '/' });
        } else {
          next();
        }
      } catch (err) {
        next();
      }
    },
  },
  {
    path: '/401',
    name: '401',
    component: FourZeroOne,
    hidden: true,
  },
  {
    name: 'NotificationTaskAction',
    path: '/task-action/:actionId',
    component: NotificationTaskAction,
    hidden: true,
  },
];

export default authRouter;
